import {LinkService} from '../../i18n/link.service'
import {IndustryOverviewPage, IndustryOverviewPageSlug} from '../types/industry-overview-page.types'
import {parseCallToAction} from './call-to-action.serde'
import {parseInspirationSection} from './inspiration-section.serde'
import {parseSupportSection} from './support-section.serde'
import {parsePresentationSection} from './presentation-section.serde'
import {parseOfferingsSection} from './offerings-section.serde'
import {parseRichTextContent} from './rich-text.serde'
import {parseIndustryItem} from './industry-section.serde'
import {parsePromotionalBannerSection} from './promotional-banner-section.serde'
import {parseKnowledgeSection} from './knowledge-section.serde'
import {parsePageMeta} from './seo.serde'
import {validateDatoCmsTypes} from './common.serde'
import {parseAsset2} from './asset.serde'
import {IndustryItemFieldsFragment, IndustryOverviewPageFieldsFragment} from '../../../../__generated__/datocms.types'
import {parseAuthorCollection} from './author.serde'
import {parseContactForm} from './contact-form.serde'

export function parseIndustryOverviewPage(
  linkService: LinkService,
  e: IndustryOverviewPageFieldsFragment,
): IndustryOverviewPage {
  const entry = validateDatoCmsTypes(e)

  return {
    title: entry.title,
    breadcrumbTitle: entry.breadcrumbTitle,
    description: entry.description,
    bannerImage: entry.bannerImage ? parseAsset2(entry.bannerImage) : undefined,
    mainCallToAction: entry.mainCallToAction ? parseCallToAction(entry.mainCallToAction) : undefined,
    secondaryCallToAction: entry.secondaryCallToAction ? parseCallToAction(entry.secondaryCallToAction) : undefined,
    doNotIndexPage: entry.seo?.doNotIndexPage || false,
    inspirationSection: e.inspirationSection ? parseInspirationSection(e.inspirationSection) : undefined,
    supportSection: e.supportSection ? parseSupportSection(e.supportSection) : undefined,
    presentationSection: e.presentationSection ? parsePresentationSection(e.presentationSection) : undefined,
    offeringsSection: parseOfferingsSection(linkService, e.offeringSection),
    readingTime: entry.readingTime,
    authors: parseAuthorCollection(entry.author),
    contentSectionPlot: entry.contentSectionPlot,
    contentSectionTitle: entry.contentSectionTitle,
    content: parseRichTextContent(entry),
    industry: {
      title: entry.industrySectionTitle,
      plot: entry.industrySectionPlot,
      items: entry.industryItems.map((i: IndustryItemFieldsFragment) => parseIndustryItem(linkService, i)),
    },
    promotionalBannerSection: entry.promotionalBannerSection
      ? parsePromotionalBannerSection(entry.promotionalBannerSection)
      : undefined,
    contactForm: entry.contactForm ? parseContactForm(entry.contactForm) : undefined,
    promotionalSection: entry.promotionalSection ? parseInspirationSection(entry.promotionalSection) : undefined,
    proDirectoryIndustries: entry.proDirectoryIndustries
      ?.split(',')
      .filter((industry): industry is string => typeof industry === 'string')
      .filter(industry => industry.length > 0),
    canonicalUrl: parsePageMeta(linkService, entry.seo)?.canonicalUrl,
    knowledgeSection: entry.knowledgeSection ? parseKnowledgeSection(entry.knowledgeSection) : undefined,
    availableLanguages: parsePageMeta(linkService, entry.seo, entry._locales).availableLanguages || [],
  }
}

export function parseIndustryOverviewPageSlugs(
  items: {
    __typename?: 'IndustryOverviewPageModelRecord'
    slug?: string | undefined
    proDirectoryIndustries?: string | undefined
  }[],
): IndustryOverviewPageSlug[] {
  return items
    .filter(i => i?.slug && i?.proDirectoryIndustries?.length)
    .map(i => ({
      slug: i!.slug!,
      industryIds:
        i!.proDirectoryIndustries
          ?.split(',')
          .filter(id => id.length > 0)
          .map(id => id.trim()) ?? [],
    }))
}
